// @flow
import React, { useState, useCallback, Fragment, useEffect } from 'react';
import { errorLogger, infoLogger } from '../../helpers';
import { Container, Button } from 'semantic-ui-react';
import Footer from 'components/Footer';
import Header from 'views/Header';
import * as cssTele2 from './Maintenance.module.css';
import * as cssComviq from './MaintenanceComviq.module.css';
import ValidationCodeInput from './ValidationCodeInput';
import { CustomerTypes } from 'Constants';
import { useSelector } from 'react-redux';
import api from 'api';
import { isComviqCustomer } from '../../helpers/customerTypeHelpers';

type Props = {
  onValidLogin: () => {},
  message?: string,
};

const Maintenance = ({ onValidLogin, message }: Props) => {
  const [password, setPassword] = useState('');

  const customerType = useSelector((state) => state.app.customerType);
  const isComviq = isComviqCustomer(customerType);
  const css = isComviq ? cssComviq : cssTele2;

  const handleInputValue = useCallback(
    (value) => {
      setPassword(value);
    },
    [setPassword]
  );

  const hanldeValidatePassword = useCallback(async () => {
    try {
      const isMelody = customerType === CustomerTypes.MELODY;
      const response = await api.maintenanceLogin({ isMelody, password });

      if (response.logedIn) {
        infoLogger({
          name: 'client-login-success',
          log: 'User succesfully logged in on maintenance page: ' + password,
        });
        onValidLogin();
      }
    } catch (error) {
      errorLogger({ name: 'client-login-fail', log: `User loginWall attempt failed: ${password}.` });
    }
  }, [password]);

  useEffect(() => {
    window.__PAGE__ = 'Maintenance';
    infoLogger({ name: 'client-page-view-maintenance', log: 'Maintenance page view' });
  }, []);
  const formatText = (text) => {
    return text
      ? text.split('\\n').map((item) => {
          return (
            <>
              {item}
              <br />
            </>
          );
        })
      : '';
  };
  return (
    <Fragment>
      <Header />
      <Container as="main" className={css.maintenance}>
        <h1 className={css.title}>Hej!</h1>
        <p className={css.text}>
          {message ? (
            <> {formatText(message)} </>
          ) : (
            <>
              Just nu jobbar vi på att göra vår tjänst lite bättre. <br /> <br />
              Men kom tillbaka om en liten stund och njut av en ännu bättre upplevelse!
            </>
          )}
        </p>
        <ValidationCodeInput className={css.input} onHasValidationCode={handleInputValue} type={'password'} />
        <Footer isComviq={isComviq} className={css.footer}>
          <Button color="blue" className={css.button} primary fluid onClick={hanldeValidatePassword}>
            Logga in
          </Button>
        </Footer>
      </Container>
    </Fragment>
  );
};

export default React.memo(Maintenance);
